<template>
  <hm-content title="角色维护">
    <div class="flex flex-between">
      <div class="flex-1 mr10" :class="{ w50: isShowDetail }">
        <div class="table-panel flex flex-between">
          <div class="table-panel">
            <el-button type="primary" plain size="small" @click="handleAdd"
              >角色录入</el-button
            >
            <!-- <el-button type="primary" plain size="small" @click="importExcel"
            >导入</el-button
          >-->
            <el-button
              type="primary"
              plain
              size="small"
              @click="output(roleUserList, 'roleTable', '角色列表')"
              >导出</el-button
            >
          </div>
          <div>
            <el-input
              clearable
              v-model.trim="roleName"
              placeholder="请输入角色名称"
              size="small"
              class="ipt mr10"
            ></el-input>
            <el-button type="primary" size="small" @click="search"
              >查询</el-button
            >
          </div>
        </div>

        <div class="table">
          <el-table
            stripe
            ref="roleTable"
            :data="roleList.records"
            style="width: 100%"
            id="table"
            size="small"
            border
          >
            <el-table-column
              type="index"
              label="序号"
              :index="index => index + (currentPage - 1) * pageSize + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="roleCode"
              label="角色编码"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="roleName"
              label="角色名称"
            ></el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-tooltip class="item" content="详情" placement="top">
                    <div class="pointer mr10" @click="showDetails(scope.row)">
                      <span class="hmicon icon-chakan blue"></span>
                    </div>
                  </el-tooltip>
                  <el-tooltip class="item" content="编辑" placement="top">
                    <div class="pointer mr10" @click="edit(scope.row)">
                      <span class="hmicon icon-bianji blue"></span>
                    </div>
                  </el-tooltip>
                  <el-tooltip class="item" content="删除" placement="top">
                    <div class="pointer mr10" @click="remove(scope.row)">
                      <span class="hmicon icon-shanchu primary"></span>
                    </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="roleList.total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total,  prev, pager, next, jumper"
            :current-page="currentPage"
            :page-size="pageSize"
          ></el-pagination>
        </div>
      </div>
      <div class="flex-1" :class="{ w50: isShowDetail }" v-show="isShowDetail">
        <div class="table-panel flex flex-between">
          <div class="table-panel">
            <el-button type="primary" plain size="small" @click="userEntry"
              >用户录入</el-button
            >
            <el-button type="primary" plain size="small" @click="addExsistdUser"
              >添加已有用户</el-button
            >
          </div>
          <div class="table-panel flex">
            <el-input
              clearable
              v-model.trim="username"
              placeholder="请输入用户账号"
              size="small"
              class="ipt mr10"
            ></el-input>
            <el-button type="primary" size="small" @click="searchDetails"
              >查询</el-button
            >
          </div>
        </div>

        <div class="table">
          <el-table
            stripe
            :data="roleUserList.records"
            style="width: 100%"
            id="table"
            size="small"
            border
          >
            <el-table-column
              type="index"
              label="序号"
              :index="
                index => index + (detailsCurrentPage - 1) * detailsPageSize + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="username"
              label="用户账号"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="realname"
              label="用户名称"
            ></el-table-column>
            <!-- <el-table-column
              header-align="center"
              align="center"
              prop="status_dictText"
              label="状态"
            ></el-table-column> -->
            <el-table-column
              label="操作"
              width="150"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <!-- <el-tooltip class="item" content="编辑" placement="top">
                    <div class="pointer mr10" @click="editUser(scope.row)">
                      <span class="hmicon icon-bianji blue"></span>
                    </div>
                  </el-tooltip> -->
                  <el-tooltip class="item" content="删除" placement="top">
                    <div
                      class="pointer mr10"
                      @click="remove(scope.row, 'details')"
                    >
                      <span class="hmicon icon-shanchu primary"></span>
                    </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="roleUserList.total"
            @current-change="detailsPaging"
            layout="total,  prev, pager, next, jumper"
            :current-page="detailsCurrentPage"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 角色录入 -->
    <el-dialog
      :title="mode === 'add' ? '新增' : '编辑'"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      width="800px"
      @close="resetForm('ruleForm')"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="large-label-form"
      >
      
        <el-form-item label="角色名称：" prop="roleName">
          <el-input
            size="small"
            clearable
            v-model.trim="ruleForm.roleName"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色编码：" prop="roleCode">
          <el-input
            size="small"
            :disabled="mode === 'edit'"
            clearable
            v-model.trim="ruleForm.roleCode"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="description">
          <el-input
            size="small"
            clearable
            type="textarea"
            v-model.trim="ruleForm.description"
          ></el-input>
        </el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button size="small" @click="resetForm('ruleForm')"
            >返回</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <!-- 用户添加 -->
    <el-drawer
      :wrapperClosable="false"
      custom-class="hm-drawer"
      :title="detailsMode === 'add' ? '新增' : '编辑'"
      :visible="drawerFormVisible"
      direction="rtl"
      :before-close="handleClose"
    >
      <div class="drawer-content">
        <el-form
          :model="detailsRuleForm"
          :rules="detailsRules"
          ref="detailsRuleForm"
          label-width="100px"
          class="large-label-form"
        >
        <el-form-item label="用户账号" prop="username">
          <el-input
            clearable
            v-model.trim="detailsRuleForm.username"
            maxlength="20"
            size="small"
            style="width:200px"
            placeholder="请输入用户账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户密码" prop="password">
          <el-input
            clearable
            autocomplete="new-password"
            style="width:200px"
            v-model.trim="detailsRuleForm.password"
            maxlength="20"
            type="password"
            size="small"
            placeholder="请输入用户密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmpassword">
          <el-input
            clearable
            type="password"
            autocomplete="new-password"
            style="width:200px"
            v-model.trim="detailsRuleForm.confirmpassword"
            maxlength="20"
            size="small"
            placeholder="请确认输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户名字" prop="realname">
          <el-input
            clearable
            style="width:200px"
            v-model.trim="detailsRuleForm.realname"
            maxlength="20"
            size="small"
            placeholder="请输入用户名字"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属机构" prop="orgCodes">
          <el-cascader
            ref="cascader"
            clearable
            style="width:200px"
            v-model="detailsRuleForm.orgCodes"
            :props="props"
            :show-all-levels="false"
            size="small"
          ></el-cascader>
        </el-form-item>
        <!-- <el-form-item label="角色分配" prop="ruleLists">
          <el-select
            v-model="detailsRuleForm.ruleLists"
            value-key="id"
            multiple
            filterable
            disabled
            style="width:200px"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, i) in roleAllList"
              :key="i"
              :label="item.roleName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
         <el-form-item label="工号" prop="workNum">
          <el-input
            maxlength="8"
            style="width:200px"
            clearable
            @input="filterGt0OrFixed2('workNum')"
            v-model.trim="detailsRuleForm.workNum"
            size="small"
            placeholder="请输入工号"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
          style="width:200px"
            clearable
            v-model.trim="detailsRuleForm.phone"
            size="small"
            type="number"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="在职状态" prop="workingState">
          <el-select
          style="width:200px"
            v-model="detailsRuleForm.workingState"
            placeholder="请选择在职状态"
             size="small"
          >
            <el-option label="在职" value="yes"> </el-option>
            <el-option label="离职" value="no"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否主管" prop="isManager">
          <el-select  style="width:200px"  size="small" v-model="detailsRuleForm.isManager" placeholder="请选择是否主管">
            <el-option label="是" value="yes"> </el-option>
            <el-option label="否" value="no"> </el-option>
          </el-select>
        </el-form-item>
          <el-form-item label="入职时间" prop="regDay">
          <el-date-picker
          style="width:200px"  size="small"
            v-model="detailsRuleForm.regDay"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select style="width:200px"  size="small" v-model="detailsRuleForm.sex" placeholder="请选择性别">
            <el-option label="男" value="1"> </el-option>
            <el-option label="女" value="2"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="生日" prop="birthday">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="detailsRuleForm.birthday"
            type="date"
            placeholder="请选择时间"
            style="width:200px"  size="small"
          >
          </el-date-picker>
        </el-form-item>
          <!-- <el-form-item label="用户账号：" prop="username">
            <el-input
              size="small"
              clearable
              autocomplete="new-password"
              v-model.trim="detailsRuleForm.username"
            ></el-input>
          </el-form-item> -->
          <!-- <el-form-item
            label="登录密码："
            prop="password"
            v-if="detailsMode === 'add'"
          >
            <el-input
              size="small"
              clearable
              autocomplete="new-password"
              type="password"
              v-model.trim="detailsRuleForm.password"
            ></el-input>
          </el-form-item> -->
          <!-- <el-form-item
            label="确认密码："
            prop="confirmpassword"
            v-if="detailsMode === 'add'"
          >
            <el-input
              size="small"
              clearable
              type="password"
              autocomplete="new-password"
              v-model.trim="detailsRuleForm.confirmpassword"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户名字：" prop="realname">
            <el-input
              size="small"
              clearable
              v-model.trim="detailsRuleForm.realname"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="手机号："
            prop="phone"
            v-if="detailsMode === 'add'"
          >
            <el-input
              size="small"
              clearable
              type="number"
              v-model.trim="detailsRuleForm.phone"
            ></el-input>
          </el-form-item>
          <el-form-item label="头像：">
            <my-upload
              field="file"
              @crop-success="cropSuccess"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              v-model="show"
              noCircle
              :width="100"
              :height="100"
              :params="{ storeId }"
              :url="$uploadUrl"
              img-format="png"
            ></my-upload>
            <div class="headPortrait-wrapper">
              <img
                @click="toggleShow"
                :src="detailsRuleForm.avatar"
                alt="头像"
              />
            </div>
          </el-form-item> -->
          <!-- <el-form-item label="生日：" prop="birthday">
            <el-date-picker
              v-model="detailsRuleForm.birthday"
              type="date"
              size="small"
            ></el-date-picker>
          </el-form-item> -->
          <!-- <el-form-item label="性别：" prop="sex">
            <el-select size="small" v-model="detailsRuleForm.sex">
              <el-option :value="1" label="男"></el-option>
              <el-option :value="2" label="女"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="邮箱：" prop="email">
            <el-input
              size="small"
              clearable
              v-model.trim="detailsRuleForm.email"
            ></el-input>
          </el-form-item> -->
        </el-form>
      </div>
      <div class="drawer-footer flex flex-center item-center">
        <el-button
          type="primary"
          size="small"
          @click="submitForm('detailsRuleForm')"
          >提交</el-button
        >
        <el-button size="small" @click="resetForm('detailsRuleForm')"
          >返回</el-button
        >
      </div>
    </el-drawer>

    <el-dialog
      title="添加已有用户"
      :close-on-click-modal="false"
      :visible.sync="exsistUserDilogVisible"
      width="800px"
      @close="exsistUserDilogVisible = false"
    >
      <div class="table-panel">
        <el-input
          clearable
          v-model.trim="user.username"
          placeholder="请输入姓名"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="searchUser"
          >查询</el-button
        >
      </div>
      <el-table
        stripe
        :data="storeUserList.records"
        @selection-change="handleSelectionChange"
        id="table"
        size="small"
        border
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          :index="
            index => index + (existUserCurrentPage - 1) * existUserPageSize + 1
          "
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="username"
          label="用户账号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realname"
          label="用户名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="status_dictText"
          label="状态"
        ></el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="storeUserList.total"
          @current-change="existUserPaging"
          layout="total,  prev, pager, next, jumper"
          :current-page="existUserCurrentPage"
        ></el-pagination>
      </div>
      <div class="flex flex-center p10">
        <el-button type="primary" size="small" @click="saveUsersRole"
          >保存</el-button
        >
        <el-button size="small" @click="calcleSetUsersRole">返回</el-button>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
// import myUpload from "vue-image-crop-upload";
import { request } from "@/utils/request";
import { outPutMixin } from "@/mixins/outputMixin";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: {},
  mixins: [outPutMixin],
  data() {
    const validatorOrgCodesFunc = function(rule, val, callback) {
      if (this.isArray(val)) {
        if (val.length <= 0) {
          return callback(new Error("请选择所属机构"));
        }
      } else {
        if (val === "") {
          return callback(new Error("请选择所属机构"));
        }
      }

      // if (this.ruleForm.password === this.ruleForm.confirmpassword) {
      //   callback();
      // } else {
      //
      // }
      callback();
    }.bind(this);
    const validatorFunc = function(rule, val, callback) {
      if (
        this.detailsRuleForm.password === this.detailsRuleForm.confirmpassword
      ) {
        callback();
      } else {
        return callback(new Error("两次输入密码不一致"));
      }
    }.bind(this);
    const checkPhone = function(rule, val, callback) {
      if (/^1[0-9]{10}$/.test(val)) {
        request({
          url: `/sys/duplicate/check`,
          method: "get",
          params: {
            tableName: "store_user",
            fieldName: "phone",
            fieldVal: val,
            dataId: this.userId
          }
        })
          .then(() => {
            callback();
          })
          .catch(() => {
            return callback(new Error("手机号已存在"));
          });
      }
    }.bind(this);
    const checkUsername = (rule, val, callback) => {
      if (val) {
        request({
          url: `/sys/duplicate/check`,
          method: "get",
          params: {
            tableName: "store_user",
            fieldName: "username",
            fieldVal: val
          }
        })
          .then(() => {
            callback();
          })
          .catch(() => {
            return callback(new Error("用户名已存在"));
          });
      }
    };
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationTree", {
                pageNo: 1,
                pageSize: 999,
                loginType: "store"
              })
              .then(res => {
                res.result.records.forEach(v => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.orgCode;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryOrganizationListByParent", {
                parentId: data.treeStruct,
                loginType: "store"
              })
              .then(res => {
                if (res.code === "0" && res.result) {
                  res.result.forEach(v => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.orgCode;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      currentRoleId: "",
      username: "",
      user: {
        username: ""
      },
      userIdList: [],
      show: false,
      storeId: "",
      drawerFormVisible: false,
      roleName: "",
      createTime: [],
      exsistUserDilogVisible: false,
      activityChildCategoryList: [],
      currentPage: 1,
      pageSize: 10,
      detailsCurrentPage: 1,
      detailsPageSize: 10,
      existUserCurrentPage: 1,
      existUserPageSize: 10,
      startDate: "",
      endDate: "",
      timeStatus: "all",
      date: [],
      mode: "add",
      isShowDetail: "",
      isOutputing: false,
      dialogFormVisible: false,
      detailsMode: "add",
      ruleForm: {
        roleName: "",
        roleCode: "",
        description: ""
      },
      currentRow: {},
      currentDetailsRow: {},
      rules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
          { min: 2, max: 30, message: "长度在 2 到 30 个字符", trigger: "blur" }
        ],
        roleCode: {
          required: true,
          message: "请输入角色编码",
          trigger: "blur"
        },
        description: {
          max: 126,
          message: "长度不超过 126 个字符",
          trigger: "blur"
        }
      },
      defaultAvatar:
        "https://imgcdn.hemiao100.com/hemiaoBase/ce9c2cec-bead-43a0-9de3-2bc3e9e16acb.png",
      roleAllList: [],
      detailsRuleForm: {
        username: "",
        realname: "",
        password: "",
        confirmpassword: "",
        phone: "",
        context: "",
        workNum: "",
        birthday: "",
        sex: "",
        regDay: "",
        workingState: "",
        isManager: "",
        ruleLists: [],
        orgCodes: [],
        address: ""
        // username: "",
        // password: "",
        // confirmpassword: "",
        // realname: "",
        // birthday: "",
        // sex: "",
        // email: "",
        // phone: "",
        // avatar:
        //   "https://imgcdn.hemiao100.com/hemiaoBase/ce9c2cec-bead-43a0-9de3-2bc3e9e16acb.png"
      },
      detailsRules: {
        username: [
          {
            required: true,
            message: "请输入用户账号！",
            trigger: "blur"
          },
          {
            max: 12,
            message: "长度应小于12个字符",
            trigger: "blur"
          },
          {
            validator: checkUsername,
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码!",
            trigger: "blur"
          },
          { min: 8, max: 12, message: "长度在8到12个字符", trigger: "blur" },
          {
            message: "只能输入数字或字母或数字与字母的组合",
            pattern: /^[0-9a-zA-Z]*$/g,
            trigger: "blur"
          }
        ],
        confirmpassword: [
          {
            required: true,
            validator: validatorFunc,
            trigger: "blur"
          },
          { min: 8, max: 12, message: "长度在8到12个字符", trigger: "blur" },
          {
            message: "只能输入数字或字母或数字与字母的组合",
            pattern: /^[0-9a-zA-Z]*$/g,
            trigger: "blur"
          }
        ],
        orgCodes: {
          required: true,
          validator: validatorOrgCodesFunc,
          message: "请选择所属机构"
        },
        workNum: {
          required: true,
          trrger: "blur",
          message: "请输入工号"
        },
        workingState: {
          required: true,
          message: "请选择在职状态"
        },
        isManager: {
          required: true,
          message: "请选择是否主管"
        },
        // phone: [
        //   {
        //     required: true,
        //     trrger: "blur",
        //     message: "请输入手机号"
        //   },
        //   {
        //     required: true,
        //     pattern: /^1[0-9]{10}$/,
        //     message: "请输入正确的手机号",
        //     trigger: "blur"
        //   }
        // ],
        realname: [
          {
            required: true,
            message: "请输入用户名称！",
            trigger: "blur"
          },
          {
            max: 12,
            message: "长度应小于12个字符",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            pattern: /^1[0-9]{10}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          },
          {
            validator: checkPhone,
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.getParamsCookie();
    this.queryList();
    this.queryAllRoleList();
  },
  mounted() {},
  computed: mapGetters([
    "roleList",
    "roleUserList",
    "allRoleUserList",
    "storeUserList"
  ]),
  watch: {
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    },
    dateAndTime(val) {
      this.startDate = val ? moment(val[0]).format("YYYY-MM-DD HH:mm:ss") : "";
      this.endDate = val ? moment(val[1]).format("YYYY-MM-DD HH:mm:ss") : "";
    }
  },
  methods: {
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryAllRoleList() {
      const params = {
        pageSize: 99999,
        pageNo: 1,
        column: "createTime",
        order: "desc",
        loginType: "store"
      };
      const { result, code } = await this.$store.dispatch(
        "queryAllRoleList",
        params
      );
      if (code == "0") {
        this.roleAllList = result.records;
      }
    },
    handleAdd() {
      this.dialogFormVisible = true;
      this.mode = "add";
    },
    userEntry() {
      this.currentRoleId = this.currentRow.id;
      this.drawerFormVisible = true;
      this.detailsRuleForm.ruleLists = [this.currentRow.id];
      this.detailsMode = "add";
    },
    addExsistdUser() {
      this.exsistUserDilogVisible = true;
      this.queryUserList();
    },
    queryUserList() {
      this.$store.dispatch("queryStoreUserList", {
        column: "createTime",
        order: "desc",
        pageNo: this.existUserCurrentPage,
        pageSize: this.existUserPageSize,
        username: this.user.username,
        roleId: this.currentRow.id,
        loginType: "store"
      });
    },
    handleSelectionChange(selection) {
      this.userIdList = selection.map(v => v.id);
    },
    saveUsersRole() {
      this.$store
        .dispatch("addExistUser", {
          roleId: this.currentRow.id,
          userIdList: this.userIdList,
          loginType: "store"
        })
        .then(res => {
          if (res.success) {
            this.exsistUserDilogVisible = false;
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryDetailsList();
          }
        });
    },
    calcleSetUsersRole() {
      this.exsistUserDilogVisible = false;
    },
    filterGt0OrFixed2(prop) {
      this.detailsRuleForm[prop] = this.detailsRuleForm[prop].replace(
        /[^\w_]/g,
        ""
      ); //过滤0开头
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      // this.ruleForm[prop] = this.ruleForm[prop]
      //   .replace(".", "$#*")
      //   .replace(/\./g, "")
      //   .replace("$#*", "."); //去除其他"."
      // this.ruleForm[prop] = this.ruleForm[prop].replace(
      //   /^(\d+)\.(\d\d).*$/,
      //   "$1.$2"
      // ); //限制只能输入两个小数
      // if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
      //   //首位是0的话去掉
      //   this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      // }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let actionName = "";
          let params = JSON.parse(JSON.stringify(this[formName]));
          if (formName === "ruleForm") {
            if (this.mode === "add") {
              actionName = "addRole";
            } else {
              actionName = "editRole";
              Object.assign(params, { id: this.currentRow.id });
            }
          } else if (formName === "detailsRuleForm") {
            // Object.assign(params, {
            //   selectedroles: this.currentRoleId
            // });
            params.orgCode = this.detailsRuleForm.orgCodes[
              this.detailsRuleForm.orgCodes.length - 1
            ];
            let list = [];

            this.detailsRuleForm.ruleLists.map(v => {
              list.push({ id: v });
            });
            params.ruleList = list;
            if (this.detailsMode === "add") {
              actionName = "addEmployee";
            } else {
              // actionName = "editUser";
            }
          }

          params.loginType = "store";
          this.$store.dispatch(actionName, params).then(res => {
            if (res.code == "0") {
              this.dialogFormVisible = false;
              this.drawerFormVisible = false;
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              if (formName === "ruleForm") {
                this.queryList();
              } else {
                this.queryDetailsList();
              }
            }
          });
        }
      });
    },
    showDetails(row) {
      this.isShowDetail = true;
      this.currentRow = row;
      this.queryDetailsList();
    },
    edit(row) {
      this.mode = "edit";
      this.currentRow = row;
      this.dialogFormVisible = true;
      for (let key in row) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = row[key];
        }
      }
    },
    remove(row, type) {
      const tip = type ? row.realname : row.roleName;
      this.$confirm(`删除<span style="color: red">${tip}</span>?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning"
      }).then(() => {
        if (type) {
          this.$store
            .dispatch("deleteUserRole", {
              roleId: this.currentRow.id,
              userId: row.id
            })
            .then(res => {
              if (res.success) {
                this.$message({
                  message: " 操作成功",
                  type: "success"
                });
                this.queryDetailsList();
              }
            });
        } else {
          this.$store
            .dispatch("deleteRole", {
              id: row.id
            })
            .then(res => {
              if (res.success) {
                this.$message({
                  message: " 操作成功",
                  type: "success"
                });
                this.queryList();
              }
            });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      for (let key in this[formName]) {
        this[formName][key] = "";
      }
      this.detailsRuleForm.avatar = this.defaultAvatar;
      this.dialogFormVisible = false;
      this.drawerFormVisible = false;
    },
    // importExcel() {},
    toDetails() {},
    handleClose() {
      this.drawerFormVisible = false;
    },
    editUser(row) {
      this.currentDetailsRow = row;
      this.drawerFormVisible = true;
      this.detailsMode = "edit";
      for (let key in row) {
        if (this.detailsRuleForm.hasOwnProperty(key)) {
          this.detailsRuleForm[key] = row[key];
        }
      }
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id
        })
        .then(() => {
          this.queryList();
        });
    },
    addActivity() {
      this.$router.push({
        name: "SelectActivity"
      });
    },
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    detailsPaging(page) {
      this.detailsCurrentPage = page;
      this.queryDetailsList();
    },
    existUserPaging(page) {
      this.existUserCurrentPage = page;
      this.queryUserList();
    },
    queryDetailsList() {
      this.$store.dispatch("queryRoleUserList", {
        roleId: this.currentRow.id,
        pageNo: this.detailsCurrentPage,
        pageSize: this.detailsPageSize,
        username: this.username,
        column: "createTime",
        order: "desc",
        loginType: "store"
      });
    },
    queryList(queryAll) {
      const params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: this.currentPage,
        roleName: this.roleName,
        column: "createTime",
        order: "desc",
        loginType: "store"
      };
      this.setParamsCookie();
      const actionName = queryAll ? "queryAllRoleList" : "queryRoleList";
      return this.$store.dispatch(actionName, params);
    },
    setParamsCookie() {
      let searchCondition = {
        roleName: this.roleName
      };
      setCookie({
        key: "roleUserListParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "roleUserListParams", type: "session" });
      if (prams) {
        this.roleName = prams.roleName;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },

    search() {
      this.currentPage = 1;
      this.queryList();
    },
    searchDetails() {
      this.detailsCurrentPage = 1;
      this.queryDetailsList();
    },
    searchUser() {
      this.existUserCurrentPage = 1;
      this.queryUserList();
    },
    cropSuccess() {},
    /**
     * upload success
     *
     * [param] jsonData   服务器返回数据，已进行json转码
     * [param] field
     */
    cropUploadSuccess(jsonData) {
      this.detailsRuleForm.avatar = jsonData.result;
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail() {},
    toggleShow() {
      this.show = !this.show;
    }
  }
};
</script>

<style scoped lang="scss">
.btn.active {
  background: #71abff;
  color: #fff;
  border-radius: 5px;
}
.btn-group {
  margin-bottom: 2rem;
}

.status {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
  margin-top: -2px;
}

.pos {
  margin-right: 5px;
  width: 15px;
  height: 15px;
  line-height: 15px;
  background: #e50163;
  color: #fff;
}

.w50 {
  width: 50%;
}

.headPortrait-wrapper {
  width: 100px;
  height: 100px;
  border: 1px solid#dcdfe6;
  cursor: pointer;
  img {
    width: 100px;
  }
}
</style>
